import React from "react"
import SeoLandingPage from "./SeoLandingPage"
import { SEO_KEYWORDS_EXTRA } from "../../seo/extraKeywords"

export default function BedAdmissionBaripada() {
  return (
    <SeoLandingPage
      path="/b-ed-admission-baripada"
      title="B.Ed Admission Baripada (Odisha) | Counselling + Coaching Support"
      description="B.Ed admission counselling + coaching support for Baripada students. Admission guidance, document support, books and online classes with Odisha-based team (Bhadrak office support)."
      keywords={`B.Ed admission Baripada, best B.Ed institute Baripada, B.Ed coaching Baripada, B.Ed college Baripada Mayurbhanj, B.Ed institute near me Baripada, BP.Ed Baripada Odisha, ${SEO_KEYWORDS_EXTRA}`}
      h1="B.Ed Admission in Baripada – Counselling + Coaching"
      intro="If you are from Baripada and looking for B.Ed admission guidance, we provide counselling, eligibility help, admission processing support, study material guidance and online coaching. Offline support is available from our Bhadrak office."
      bullets={[
        "B.Ed admission counselling for Baripada students",
        "Online coaching/classes + study material guidance",
        "Admission processing + form fill-up support",
        "Document checklist and verification support",
        "Books/study material distribution support",
        "Support for Baripada and nearby areas across Mayurbhanj",
      ]}
      areaServed={[
        { "@type": "City", name: "Baripada" },
        { "@type": "City", name: "Bhadrak" },
        { "@type": "State", name: "Odisha" },
      ]}
      faqs={[
        {
          q: "Do you provide coaching for Baripada students?",
          a: "Yes. We provide admission guidance plus coaching support through online classes and study material guidance.",
        },
        {
          q: "Can I complete the process online from Baripada?",
          a: "Yes. Most steps can be handled online. If needed, you can visit the Bhadrak office for offline support and books.",
        },
        {
          q: "Which areas near Baripada do you support?",
          a: "We support students from across Mayurbhanj district and other parts of Odisha.",
        },
      ]}
    />
  )
}

